import React, { useEffect } from "react";
import lines2 from "../assets/imgs/BG Effects/Lines 2.png";
import icon1 from "../assets/imgs/icons/1.png";
import icon2 from "../assets/imgs/icons/2.png";
import icon3 from "../assets/imgs/icons/3.png";
import icon4 from "../assets/imgs/icons/4.png";

const About = () => {

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-effect");

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target); // Animate once
        }
      });
    }, { threshold: 0.2 });

    elements.forEach(el => observer.observe(el));

    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <section id="about" className="about">
      <div className="about-img">
        <img src={lines2} alt="" />
      </div>
      <div className="title">
        <h1 id="title" class="scroll-effect">ABOUT</h1>
        <p id="about-content" className="scroll-effect">
          We are a passionate team of medical innovators dedicated to developing intelligent, human-centered solutions that restore comfort, enhance mobility,
          and empower independence in people’s everyday lives. Guided by empathy and driven by technology, we strive to transform healthcare experiences through
          innovation that brings dignity, safety, and confidence to every individual we serve.
        </p>
      </div>

      <div className="card-section">
        <div className="card-outline scroll-effect">
          <div className="card">
            <img src={icon1} alt="mission-1" />
          </div>
          <h2>Empowering Independence</h2>
        </div>

        <div className="card-outline scroll-effect">
          <div className="card">
            <img src={icon2} alt="mission-2" />
          </div>
          <h2>Innovating with Compassion</h2>
        </div>

        <div className="card-outline scroll-effect">
          <div className="card">
            <img src={icon3} alt="mission-3" />
          </div>
          <h2>Redefining Mobility and Accessibility</h2>
        </div>

        <div className="card-outline scroll-effect">
          <div className="card">
            <img src={icon4} alt="mission-4" />
          </div>
          <h2>Advancing Human COMFORTED Healthcare</h2>
        </div>
      </div>
    </section>
  );
};

export default About;
